import PropTypes from 'prop-types';
import { __ } from '@web-stories-wp/i18n';
import { DropDown } from '@web-stories-wp/design-system';
import { MULTIPLE_DISPLAY_VALUE, MULTIPLE_VALUE } from '../../../../constants';
import {
  TEXT_EFFECT_BLEND_MODE,
  TEXT_EFFECT_BLEND_MODES,
} from '../../../../elements/shared/blendModes';
import { FieldRow } from './textEffectStyles';

const LABELS = {
  [TEXT_EFFECT_BLEND_MODE.NORMAL]: __('Normal', 'web-stories'),
  [TEXT_EFFECT_BLEND_MODE.MULTIPLY]: __('Multiply', 'web-stories'),
  [TEXT_EFFECT_BLEND_MODE.SCREEN]: __('Screen', 'web-stories'),
  [TEXT_EFFECT_BLEND_MODE.OVERLAY]: __('Overlay', 'web-stories'),
  [TEXT_EFFECT_BLEND_MODE.DARKEN]: __('Darken', 'web-stories'),
  [TEXT_EFFECT_BLEND_MODE.LIGHTEN]: __('Lighten', 'web-stories'),
  [TEXT_EFFECT_BLEND_MODE.COLOR_DODGE]: __('Color Dodge', 'web-stories'),
  [TEXT_EFFECT_BLEND_MODE.COLOR_BURN]: __('Color Burn', 'web-stories'),
  [TEXT_EFFECT_BLEND_MODE.HARD_LIGHT]: __('Hard Light', 'web-stories'),
  [TEXT_EFFECT_BLEND_MODE.SOFT_LIGHT]: __('Soft Light', 'web-stories'),
  [TEXT_EFFECT_BLEND_MODE.DIFFERENCE]: __('Difference', 'web-stories'),
  [TEXT_EFFECT_BLEND_MODE.EXCLUSION]: __('Exclusion', 'web-stories'),
  [TEXT_EFFECT_BLEND_MODE.LINEAR_BURN]: __('Linear Burn', 'web-stories'),
};

export const TEXT_EFFECT_BLEND_MODE_OPTIONS = TEXT_EFFECT_BLEND_MODES.map(
  (value) => ({ value, label: LABELS[value] })
);

function TextEffectBlendMode({
  label,
  visibleLabel = __('Blend mode', 'web-stories'),
  value,
  onChange,
}) {
  return (
    <FieldRow>
      <span>{visibleLabel}</span>
      <DropDown
        ariaLabel={label}
        options={TEXT_EFFECT_BLEND_MODE_OPTIONS}
        selectedValue={value === MULTIPLE_VALUE ? '' : value}
        placeholder={value === MULTIPLE_VALUE ? MULTIPLE_DISPLAY_VALUE : ''}
        onMenuItemClick={(_event, next) => onChange(next)}
      />
    </FieldRow>
  );
}

TextEffectBlendMode.propTypes = {
  label: PropTypes.string.isRequired,
  visibleLabel: PropTypes.string,
  value: PropTypes.oneOf([...TEXT_EFFECT_BLEND_MODES, MULTIPLE_VALUE])
    .isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TextEffectBlendMode;
